export default "__VITE_ASSET__D0Z16s6w__"